import { formatDateStringToObject } from "syf-js-utilities";
var dateFormatOption = {
    month: "short",
    day: "numeric",
    year: "numeric",
};
var formatMonthDayYearDate = function (date) {
    return formatDateStringToObject(date).toLocaleDateString("en-US", dateFormatOption);
};
export default formatMonthDayYearDate;
